import React from "react";
import { Link } from "react-router-dom";
import { Bed, Bathtub, ArrowUpRight, MapPin } from "@phosphor-icons/react";

export const PropertyCard = ({ property, index = 0 }) => {
  return (
    <Link
      to={`/properties/${property.slug}`}
      className="card-property block fade-in-up"
      style={{ animationDelay: `${index * 80}ms` }}
      data-testid={`property-card-${property.slug}`}
    >
      <div className="relative overflow-hidden">
        <div className="aspect-[4/3] w-full overflow-hidden bg-[var(--bg-secondary)]">
          {property.coming_soon ? (
            <div className="w-full h-full flex items-center justify-center bg-[var(--brand)] text-white">
              <div className="text-center px-6">
                <div className="label-uppercase !text-[var(--accent)]">Watch this space</div>
                <div className="font-display text-4xl md:text-5xl tracking-tighter mt-3">Coming Soon</div>
                <div className="mt-3 text-sm text-white/70">Our third Hull rental is on the way.</div>
              </div>
            </div>
          ) : (
            <img
              src={property.hero_image}
              alt={property.name}
              className="cover-image w-full h-full object-cover"
              loading="lazy"
            />
          )}
        </div>
        <div className="absolute top-4 left-4">
          {property.coming_soon ? (
            <span className="tag-let" style={{ background: 'var(--accent)', color: 'var(--brand)' }} data-testid={`property-${property.slug}-status`}>Coming Soon</span>
          ) : property.available ? (
            <span className="tag-available" data-testid={`property-${property.slug}-status`}>Available</span>
          ) : (
            <span className="tag-let" data-testid={`property-${property.slug}-status`}>Let Agreed</span>
          )}
        </div>
        <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-1.5 text-xs font-semibold tracking-wider uppercase">
          {property.target}
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="h3 text-xl md:text-2xl">{property.name}</h3>
            <div className="mt-1 flex items-center gap-1 text-sm text-[var(--text-tertiary)]">
              <MapPin size={14} weight="regular" />
              <span>{property.address}{property.postcode ? `, ${property.postcode}` : ', Hull'}</span>
            </div>
          </div>
          <ArrowUpRight size={22} className="shrink-0 mt-1 text-[var(--text-primary)]" />
        </div>

        <p className="mt-4 text-sm text-[var(--text-secondary)] line-clamp-2">{property.tagline}</p>

        <div className="mt-6 border-t border-[var(--border-subtle)] pt-4">
          {property.coming_soon ? (
            <div className="flex items-center justify-between">
              <span className="text-sm text-[var(--text-tertiary)]">Details soon</span>
              <span className="label-uppercase text-[var(--text-tertiary)]">TBC</span>
            </div>
          ) : (
            <>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4 text-sm text-[var(--text-secondary)]">
                  <span className="flex items-center gap-1.5"><Bed size={16} /> {property.bedrooms} bed</span>
                  <span className="flex items-center gap-1.5"><Bathtub size={16} /> {property.bathrooms} bath</span>
                </div>
                {property.bills_included && (
                  <span className="text-[10px] uppercase tracking-[0.15em] font-bold text-[var(--brand)] bg-[var(--bg-tertiary)] px-2 py-1">Bills inc.</span>
                )}
              </div>
              <div className="mt-4 flex items-end justify-between">
                {property.price_pppw ? (
                  <div>
                    <div className="font-display font-semibold text-2xl tracking-tight text-[var(--brand)]" data-testid={`property-${property.slug}-price`}>
                      £{property.price_pppw} <span className="text-sm font-medium text-[var(--text-secondary)]">pppw</span>
                    </div>
                    <div className="text-[11px] uppercase tracking-[0.15em] text-[var(--text-tertiary)] mt-0.5">
                      bills inclusive · approx £{property.price_pcm.toLocaleString()} pcm
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="font-display font-semibold text-2xl tracking-tight text-[var(--brand)]" data-testid={`property-${property.slug}-price`}>
                      £{property.price_pcm.toLocaleString()} <span className="text-sm font-medium text-[var(--text-secondary)]">pcm</span>
                    </div>
                    <div className="text-[11px] uppercase tracking-[0.15em] text-[var(--text-tertiary)] mt-0.5">per calendar month</div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </Link>
  );
};
